import { ReactNode, Children } from 'react';
import { Controller, FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

const ValidatedTextField = ({
  name,
  children,
  getError = (x) => x,
  getHelperText = (x) => x,
  defaultValue = '',
  helperText = '',
  ...controllerProps
}: {
  name: string;
  children: ReactNode
  [key: string]: any;
  defaultValue?: string;
  getError?: <T>(value: T) => T;
  getHelperText?: <T>(value: T) => T;
  helperText?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
}) => (
  <Controller
    {...controllerProps}
    name={name}
    defaultValue={defaultValue}
    render={({
      field,
      fieldState,
      formState,
    }) => {
      const TextFieldComponent = Children.only(children) as { props: any; type: any };

      const {
        onChange = () => {},
        onBlur = () => {},
        ...restTextFieldProps
      } = TextFieldComponent.props;

      const handleChange = (e: Event) => {
        field.onChange(e);
        onChange(e);
      };

      const handleBlur = (e: Event) => {
        field.onBlur();
        onBlur(e);
      };

      const serverError = formState?.errors?.root?.[name];
      return (
        // eslint-disable-next-line react/jsx-pascal-case
        <TextFieldComponent.type
          {...restTextFieldProps}
          inputRef={field.ref}
          value={field.value}
          name={field.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={getError(fieldState.invalid || !!serverError)}
          helperText={
            getHelperText(fieldState.error?.message || serverError?.message || helperText)
          }
        />
      );
    }}
  />
);

export default ValidatedTextField;
